import { TeamDashboardAPI } from 'api';
import { useQuery } from 'react-query';

export const useGetDashboardFilterEnums = () => {
  return useQuery(
    ['team-dashboard-filter-enums'],
    () => TeamDashboardAPI.getTeamDashboardFilterEnums(),
    {
      staleTime: 0
    }
  );
};
